import { render, staticRenderFns } from "./EditorColumn.vue?vue&type=template&id=636b27dc&"
import script from "./EditorColumn.vue?vue&type=script&lang=js&"
export * from "./EditorColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports